<template>

    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-users text-primary mr-2"></i>
                    Gestión de Socios
                </h4>
            </b-col>
        </b-row>

        <b-row md="12" class="pb-3">
            <b-col class="col-md-12">
                <b-row md="12">

                    <b-card class="w-100">
                        <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                            Socios
                            <div>
                                <button
                                    :disabled="count<1"
                                    class="btn btn-primary btn-sm mr-2"
                                    @click="exportMembers('csv')">
                                    <i class="fa fa-download"></i> CSV
                                </button>
                                <button
                                    :disabled="count<1"
                                    class="btn btn-primary btn-sm"
                                    @click="exportMembers('xlsx')">
                                    <i class="fa fa-download"></i> Excel
                                </button>
                                <button
                                    :disabled="count<1"
                                    class="btn btn-primary btn-sm ml-2"
                                    @click="exportMembers('pdf')">
                                    <i class="fa fa-download"></i> PDF
                                </button>
                            </div>
                        </b-row>
                        <b-row md="12" class="mb-3 border-top-primary px-2">
                            <b-col class="col-md-5">
                                <!-- ////////////////////// Buscar ////////////////////// !-->
                                <b-form-group label="Buscar" :label-cols="3" :horizontal="true" class="w-100 mb-0">
                                    <b-form-input
                                        id="string"
                                        name="string"
                                        type="text"
                                        placeholder="Busqueda general"
                                        v-model="entity.string"
                                        class="w-100"
                                        v-validate="'min:3'"
                                        :state="validateState('string')"
                                        aria-describedby="check_string"></b-form-input>
                                    <div class="text-danger text-right" id="check_string">
                                        <small>{{ errors.first('string') }}</small>
                                    </div>
                                </b-form-group>
                                <!-- !-->
                            </b-col>

                            <b-col class="col-md-5">
                                <!-- ////////////////////// Sede ////////////////////// !-->
                                <b-form-group label="Sede" :label-cols="2" :horizontal="true" class="w-100 ml-2 mb-0">
                                    <headquarters-selector
                                        v-model="entity.headquarters"
                                        :allowEmpty="true"></headquarters-selector>
                                </b-form-group>
                                <!-- !-->
                            </b-col>

                            <b-col class="col-md-2">
                                <button
                                    class="btn btn-pill btn-primary ml-4 float-right"
                                    @click="search">Buscar Socio
                                </button>
                            </b-col>

                        </b-row>

                        <v-server-table
                            :columns="columns"
                            :options="options"
                            :theme="theme"
                            class="dataTable"
                            ref="dataTable"
                            md="12"
                            lg="12"
                            sm="12"
                            @sorted="tableSorted">
                            <template slot="beforeBody">
                                <tr v-if="loading">
                                    <td class="text-center loading" colspan="7"><spinner size="medium" line-fg-color="#025542" line-bg-color="#c8ced3"></spinner></td>
                                </tr>
                            </template>
                            <template slot="uuid" slot-scope="props">
                                <router-link :to="{ path: '/partners/accounts/edit/'+props.row.uuid }">
                                    <i class="fa fa-pencil"></i>
                                </router-link>
                            </template>
                            <template slot="headquarters" slot-scope="props">
                                <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                                <template>{{ props.row.headquarters.name }}</template>
                            </template>
                            <template slot="emails" slot-scope="props">
                                <div v-html="getMemberEmailsAsString(props.row.emails)"></div>
                            </template>
                        </v-server-table>
                    </b-card>

                </b-row>
            </b-col>
        </b-row>
    </div>
</template>

<script>

    import Vue from 'vue';
    import Multiselect from 'vue-multiselect';
    import {setupCalendar, DatePicker} from 'v-calendar';
    import 'v-calendar/lib/v-calendar.min.css';
    import form from '@/helpers/form';
    import {ServerTable, Event} from 'vue-tables-2';
    import {downloadJsonAsCsv, downloadJsonAsXlsx} from '@/helpers/js-xlsx';
    import {downloadJsonAsPdf} from '@/helpers/js-pdf';
    import headquartersSelector from '@/components/headquarters/HeadquartersSelector';
    import Spinner from 'vue-simple-spinner';

    Vue.use(ServerTable);

    setupCalendar({
        firstDayOfWeek: 2,// Monday
    });

    export default {
        name: 'listPartners',
        components: {
            'v-date-picker': DatePicker,
            Multiselect,
            headquartersSelector,
            Spinner
        },
        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Inicio',
                        path: '/admin/dashboard',
                        brand: 'fa fa-home'
                    },
                    {
                        name: 'Agregar Socio',
                        path: '/partners/accounts/add',
                        brand: 'fa fa-user',
                        permissions: ['REGISTER_MEMBER']
                    },
                ],
                entity: {
                    headquarters: null,
                    string: null,
                    page: 1,
                    itemsPerPage: 10,
                },
                orderBy: {
                    column: null,
                    ascending: null
                },
                count: 0,
                loading: true,
                options: {
                    headings: {
                        uuid: {
                            text: '',
                            id: 'fit'
                        },
                        name: 'Nombre',
                        code: 'Código',
                        surname: 'Apellidos',
                        nif: 'NIF',
                        emails: 'Emails',
                        headquarters: 'Sede',
                    },
                    requestFunction: data => {
                        if (this.$store.getters.getFilters[0] !== null) {
                          this.entity.string = this.$store.getters.getFilters[0];
                        }
                        if (this.$store.getters.getFilters[1] !== null) {
                          this.entity.headquarters = this.$store.getters.getFilters[1];
                        }
                        this.entity.page = data.page;
                        this.entity.itemsPerPage = data.limit;
                        let self = this;
                        return axios({
                            url: 'members/',
                            method: 'get',
                            params: this.searchFilters
                        }).catch(function (e) {
                            self.dispatch('error', e);
                        }.bind(this));
                    },
                    responseAdapter: ({data}) => {
                        return {
                            data: data.members,
                            count: data.count
                        }
                    },
                    columnsClasses: {uuid: "fit"},
                    sortable: ['code', 'name', 'surname', 'nif', 'emails', 'headquarters'],
                    filterable: false,
                    sortIcon: {
                        base: 'fa',
                        up: 'fa-sort-asc',
                        down: 'fa-sort-desc',
                        is: 'fa-sort'
                    },
                    perPageValues: [10, 25, 50, 100, 500, 1000, 10000, 100000],
                    texts: form.tableLabels(),
                    pagination: {
                        chunk: 10,
                        edge: true,
                        nav: 'scroll'
                    }
                },
                columns: [
                    'uuid',
                    'code',
                    'name',
                    'surname',
                    'nif',
                    'emails',
                    'headquarters'
                ],
                useVuex: false,
                theme: 'bootstrap4',
                template: 'default',
                strings: ['companyWorkersNumber'],
                arrays: ['addresses']
            }
        },
        mounted() {
            this.$_loadingMixin_showLoading();
            // vue-tables events
            Event.$on('vue-tables.loading', (data) => {
                this.$_loadingMixin_showLoading();
                this.count = 0;
                this.loading = true;
                //this.$refs.dataTable.data = [];
                if (!!document.querySelector('.VueTables__no-results')) {
                    document.querySelector('.VueTables__no-results').style.display = 'none';
                }
            });
            Event.$on('vue-tables.loaded', (data) => {
                if (!!data && !!data.data && !!data.data.count) {
                    this.count = data.data.count;
                }
                this.$_loadingMixin_hideLoading();
                this.loading = false;
                if (!!document.querySelector('.VueTables__no-results')) {
                    document.querySelector('.VueTables__no-results').style.display = 'table-row';
                }
            });

            this.$eventHub.$emit('captureMenu', this.topmenu);
        },
        computed: {
            searchFilters() {
                return {
                    headquartersId: !!this.entity.headquarters ? this.entity.headquarters.uuid : null,
                    string: this.entity.string,
                    page: this.entity.page,
                    itemsPerPage: this.entity.itemsPerPage,
                    orderColumn: this.orderBy.column,
                    orderAscending: this.orderBy.ascending ? 1 : 0
                }
            }
        },
        methods: {
            search() {
                let filterData = [];
                filterData.push(this.entity.string);
                filterData.push(this.entity.headquarters);
                this.$store.commit('SET_FILTERS_LIST', filterData);
                this.$refs.dataTable.refresh();
            },
            validate() {
                // FIXME
                return true;
            },
            validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return !this.errors.has(ref);
                } else {
                    return null;
                }
            },
            getMemberEmailsAsString(emails) {
                let string = '';
                if (Array.isArray(emails) && emails.length) {
                    emails.forEach((email, index) => {
                        string = string + (index > 0 ? '<br>' : '') + email.email;
                    });
                }
                return string;
            },
            normalizeMember(member) {
                let emails = null;
                if (member.emails !== undefined) {
                    emails = member.emails.reduce(
                        (accumulator, currentMember) => accumulator + currentMember.email + ' ',
                        ''
                    )
                }
                let headquarters = null;
                if (member.headquarters !== undefined) {
                    headquarters = member.headquarters.name
                }
                return {
                    'Código': member.code,
                    'Nombre': member.name,
                    'Apellidos': member.surname,
                    'NIF': member.nif,
                    'Emails': emails,
                    'Sede': headquarters
                }
            },
            async exportMembers(format) {
                if (this.count > 0) {
                    this.$_loadingMixin_showLoading();

                    let response = await axios({
                        method: 'get',
                        url: 'members',
                        params: {
                            page: 1,
                            itemsPerPage: this.entity.itemsPerPage,
                            headquartersId: !!this.entity.headquarters ? this.entity.headquarters.uuid : null,
                            string: this.entity.string
                        }
                    });

                    let self = this;
                    let rows = response.data.members.map(function (member) {
                        return self.normalizeMember(member);
                    });

                    if (format === 'csv') {
                        downloadJsonAsCsv(rows);
                    } else if (format === 'xlsx') {
                        downloadJsonAsXlsx(rows);
                    } else if (format === 'pdf') {
                        downloadJsonAsPdf(rows);
                    }

                    this.$_loadingMixin_hideLoading();
                }
            },
            tableSorted(data) {
                this.orderBy.column = data.column;
                this.orderBy.ascending = data.ascending;
            }
        },
    }
</script>

<style lang="scss">
    .VueTables__no-results {
        display: none;
    }
</style>
